import React, {Component} from "react"
import {connect} from "react-redux"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../../Grid"
import Button from "../../Button"

class Finish extends Component {
  componentDidMount() {
    let amountOfPossibleFails = Math.ceil(this.props.questionslength * window.DP_ENV.QUIZ_MAX_FAILURES) + 1
    if (amountOfPossibleFails > this.props.fails) {
      this.props.markAsDone(true)
    } else {
      this.props.markAsDone()
    }
    document.querySelector(".quiz-steps li.last").classList.add("active")
  }

  renderFailLinks(item, key) {
    return (
      <li key={key}>
        <i className="icon icon-arrow-right" />
        <a href={item.link}>{item.link_text}</a>
      </li>
    )
  }

  render() {
    const {questions, fails, t} = this.props
    let amountOfPossibleFails = Math.ceil(this.props.questionslength * window.DP_ENV.QUIZ_MAX_FAILURES) + 1

    return (
      <div className="quiz-finish">
        {fails >= amountOfPossibleFails ? (
          <Container>
            <Row>
              <Col lg={8} xl={8} className="question-text  complete-fail">
                <p className="suptitle">
                  {t(
                    "Du hast leider zu viele Fragen nicht komplett richtig beantwortet."
                  )}
                </p>
                <div
                  className="headline"
                  dangerouslySetInnerHTML={{__html: questions.complete_fail}}
                />
              </Col>
              {questions.complete_fail_links ? (
                <Col lg={8} xl={8} className="quiz-fail-links">
                  <div className="inside">
                    <p className="title">
                      {t("Diese Artikel solltest du dir nochmal anschauen!")}
                    </p>
                    <ul>
                      {questions.complete_fail_links.map(this.renderFailLinks)}
                    </ul>
                  </div>
                </Col>
              ) : null}
              <Col lg={10} xl={8} className="quiz-buttons last">
                <Button
                  onClick={() => this.props.closeQuiz(false)}
                  theme="purple"
                  to={`#`}
                >
                  {t("Quiz schließen")}
                </Button>
              </Col>
            </Row>
          </Container>
        ) : (
          <Container>
            <Row>
              <Col lg={8} xl={6} className="question-text complete-success">
                <p className="suptitle">
                  {t("Du hast")} {this.props.questionslength - fails} {t("von")}{" "}
                  {this.props.questionslength} {t("Fragen richtig gelöst!")}
                </p>
                <div
                  className="headline"
                  dangerouslySetInnerHTML={{__html: questions.complete_success}}
                />
              </Col>
              <Col lg={10} xl={8} className="quiz-buttons last">
                <Button
                  onClick={() => this.props.closeQuiz(true)}
                  theme="purple"
                  to={`#`}
                >
                  {t("Quiz schließen")}
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

Finish = connect(mapStateToProps)(Finish)
export default translate()(Finish)



// WEBPACK FOOTER //
// ./src/components/Quiz/Finish/index.js